import React from "react";
import FormCreatorComponent from "../../../../../components/generic/formbuilder/creator/FormCreatorComponent";
import { useNavigate } from "react-router-dom";
import { RoleToLinkMapper } from "../../../../utils/UrlUtils";
import { useGetRole } from "../../../hooks/useGetRole";

/**
 * This component is used for form creation
 */
const FormCreatorWrapper = () => {
  const navigate = useNavigate();
  const role = useGetRole();

  function navigateToFormBuilder() {
    navigate(RoleToLinkMapper(role) + "form-builder");
  }

  return (
    <div className="form" style={{ padding: "20px" }}>
      <FormCreatorComponent initialFormData={{}} onFormSubmit={navigateToFormBuilder} shouldEditForm={false} templateCode={""} userData={[]} />
    </div>
  );
};

export default FormCreatorWrapper;
